<ng-template #template>
  <div [class]="cssClasses.controlLabel">
    <sv-ng-string [model]="item.locText"></sv-ng-string>
  </div>
</ng-template>
